import actionTypes from './actionTypes';

export const initialState = {
  modal: null,
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.MODAL_UNSET:
      return initialState;
    case actionTypes.MODAL_SET:
      return {
        ...state,
        modal: action.modal,
      };
    case actionTypes.MODAL_ADVERT_SET: // TODO: verify that we need this
      return {
        ...state,
        modal: action.modal,
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/shared/modal/reducer.js